import React from 'react'
import S from './CraneHeader.module.scss'
import { Container } from '@shared/components/Atoms/Container/Container.component'
import { useTranslations } from '@shared/context/useTranslations';
import { Icon } from '@shared/components/Molecules/Icon/Icon.component';
import { IconNames } from "@shared/enums/icons.enums";
import { useCrane } from '@shared/context/CraneContext';
import { getRoutePathByPageType } from '@shared/helpers/findPathForSystemSite';
import { Link } from "react-router-dom";
import { cn } from '@shared/helpers/classNames.helper';

export const CraneHeader: React.FC = () => {
    const { exitCraneMode, craneInfo, resetCranePage, isOutsideCraneMode } = useCrane();
    const { getTranslation } = useTranslations();
    const craneUrl = `${getRoutePathByPageType("Crane") || "/crane/"}${craneInfo?.serialNumber || ""}`;

    return (
        <div className={S.craneHeader}>
            <Container noTopPadding noBottomPadding className={S.craneHeaderContainer}>
                
                <Link to={craneUrl} onClick={resetCranePage} className={cn(S.craneHeaderLink, { [S.showLink]: isOutsideCraneMode })}>
                    <p className={S.craneHeaderLabel}>{isOutsideCraneMode ? getTranslation("craneHeader.returnLabel") : getTranslation("craneHeader.serial", { serial: craneInfo?.serialNumber || "" })}</p>
                    <h2 className={S.craneHeaderTitle}>{isOutsideCraneMode ? getTranslation("craneHeader.returnTitle", { craneName: craneInfo?.craneName || "" }) : craneInfo?.craneName}</h2>
                </Link>
                <button className={S.craneHeaderButton} onClick={exitCraneMode}>
                    <Icon className={S.craneHeaderIcon} iconName={IconNames.Close} text={getTranslation("craneHeader.exit")} />
                </button>
            </Container>
        </div>
    )
}
